<template>
  <div class="container">
    <h4 class="title is-4">Email Evaluators</h4>
    <hr />
    <loading-box v-if="!evaluatorsLoaded"></loading-box>
    <div v-if="evaluatorsLoaded">
      <div class="filters">
        <div class="select pagination-select">
          <select v-model="filters.pageSize" @change="refreshData()">
            <option :value="20">20 per page</option>
            <option :value="50">50 per page</option>
            <option :value="100">100 per page</option>
            <option :value="100">250 per page</option>
            <option :value="999999">All results</option>
          </select>
        </div>

        <div class="select" style="marginRight: 1.5rem;">
          <select v-model="filters.status" @change="refreshData()">
            <option value="">All</option>
            <option v-for="(status, value) in statuses" :key="value" :value="value">{{
              status
            }}</option>
          </select>
        </div>

        <div class="application-filter">
          <label class="label" style="marginRight: 0.5rem;"
            >View evaluators with assigned applications</label
          >
          <input
            type="checkbox"
            class="checkbox"
            :true-value="true"
            false-value=""
            @change="refreshData()"
            v-model="filters.assignedApplications"
          />
        </div>
      </div>
      <div v-if="bulkEmailShow">
        <button
          class="button"
          style="float: right"
          @click="showModal = true"
          :disabled="!selectedEvaluators.length"
        >
          Bulk Email Selected Evaluators
        </button>
      </div>
      <pagination
        :pagination-details="paginationDetails"
        @update="refreshData($event)"
      ></pagination>

      <div class="selection-details">
        <label class="label" style="marginRight: 0.5rem;">Select all on page</label>
        <input
          type="checkbox"
          class="checkbox"
          style="marginRight: 1rem;"
          v-model="selectPage"
          @change="toggleSelectPage"
        />
        <p v-if="selectedEvaluators.length">{{ selectedEvaluators.length }} selected</p>
      </div>

      <table class="table is-fullwidth" style="marginTop: 1rem;">
        <thead>
          <tr>
            <th>Send Bulk Email</th>
            <th>Name</th>
            <th>Manual Email Sent</th>
            <th>Record Manual Email</th>
            <th>Send Individual Email</th>
            <th>Copy Magic Link</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="evaluator in evaluators" :key="evaluator.id">
            <td>
              <input
                type="checkbox"
                class="checkbox"
                :value="evaluator"
                v-model="selectedEvaluators"
              />
            </td>
            <td>
              <router-link 
              :to="{ name: 'EvaluatorDetail', params: { evaluatorId: evaluator.id } }"
              target="_blank"
              >{{ evaluator.fullName }}
              </router-link>
            </td>
            <td class="has-text-centered">
              <i class="fa fa-check" v-if="evaluator.manualEmailSent"></i>
            </td>
            <td>
              <button class="button" @click="manuallyToggleEmail(evaluator)">
                Record Manual Email
              </button>
            </td>
            <td>
              <button class="button" @click="sendEmailToEvaluator(evaluator)">
                Send Individual Email
              </button>
            </td>
            <td>
              <button class="button" @click="copyMagicLinkToClipboard(evaluator)">
                Copy Magic Link
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <BulkEmailModal
        v-if="showModal"
        :users="selectedEvaluators"
        @close="showModal = !showModal"
        @submit="refreshData()"
      />
    </div>
  </div>
</template>

<script>
import copyToClipboard from 'copy-to-clipboard'

import store from '@/vuex/store'
import User from '@/services/users'
import { getPaginationDataFromResponse } from '@/services/pagination'

import LoadingBox from '@/components/LoadingBox'
import Pagination from '@/components/Pagination'
import BulkEmailModal from '@/components/emails/BulkEmailModal'

export default {
  components: { LoadingBox, Pagination, BulkEmailModal },
  data() {
    return {
      cohorts: [],
      filters: {
        isEvaluator: true,
        status: 'ACTIVE',
        assignedApplications: '',
        pageSize: 50,
      },
      evaluators: [],
      evaluatorsLoaded: false,
      selectedEvaluators: [],
      showModal: false,
      statuses: User.evaluatorStatuses,
      paginationDetails: {},
      selectPage: false,
      bulkEmailShow: true,
    }
  },
  watch: {
    selectedEvaluators(newEvaluators) {
      //console.log("selectedEvaluators");
      //console.log(this.selectedEvaluators);
      //console.log(newEvaluators);
      if (newEvaluators.length !== this.evaluators.length) {
        this.selectPage = false
      }
      newEvaluators.forEach((value, index) => {
        //console.log(value.status);
        if (value.status == "CANCELED")
        {
          //console.log ("CANCELED!!!!!")
          this.$delete(newEvaluators, index) 
        }
      });
 
      //console.log(newEvaluators);
      //console.log(this.selectedEvaluators);
    },
  },
  created() {
    this.refreshData()
  },
  methods: {
    refreshData(page = null) {

      //console.log(this.filters.status)
      if (this.filters.status === "CANCELED")
      {
        this.bulkEmailShow = false
      }else{
        this.bulkEmailShow = true
      }
      //console.log(this.bulkEmailShow)
      this.showModal = false
      this.evaluatorsLoaded = false
      this.selectedEvaluators = []

      let dataFilters = {}
      if (page) {
        dataFilters = { ...this.filters, page: page }
      } else {
        dataFilters = { ...this.filters }
      }

      User.api
        .list({ filters: dataFilters })
        .then(response => {
          this.paginationDetails = getPaginationDataFromResponse(response)
          const evaluators = response.results
          this.evaluators = evaluators
        })
        .finally(() => {
          this.evaluatorsLoaded = true
        })
    },
    copyMagicLinkToClipboard(evaluator) {
      //console.log("copyMagicLinkToClipboard");
      const emailURL = `users/${evaluator.id}/get-magic-link/`
      const emailPromise = store.getters.apiClient.get(emailURL)
      emailPromise.then(response => {
        const data = response.data
        copyToClipboard(`${data.magic_link}`)
        this.$Alert.alert({
          type: 'info',
          message: `<p>Copied</p>`,
          timeout: 6000,
        })
      })
    },
    manuallyToggleEmail(evaluator) {
      //console.log("manuallyToggleEmail");
      // TODO: Because I have the cohort (which only has a UserRef) and the cohort is not using the class structure,
      // I'm doing some gymnastics to update the user on the server while also
      // updating the cohort's user on the front end. I will fix this later.
      User.api.get(evaluator.id).then(data => {
        const toggledUser = data
        data.manualEmailSent = !evaluator.manualEmailSent
        const fields = ['manualEmailSent']
        User.api.update(toggledUser, fields).then(() => {
          evaluator.manualEmailSent = !evaluator.manualEmailSent
        })
      })
    },
    toggleSelectPage() {
      //console.log("toggleSelectPage");
      if (this.selectPage) {
        this.selectedEvaluators = [...this.evaluators]
      } else {
        this.selectedEvaluators = []
      }
    },
    sendEmailToEvaluator(evaluator) {
      //console.log("sendEmailToEvaluator");
      if (this.selectPage) {
        this.toggleSelectPage()
      } else {
        this.selectedEvaluators = []
      }
      this.selectedEvaluators = [evaluator]
      this.showModal = true
    },
  },
}
</script>

<style scoped lang="scss">
.tag {
  margin: 0 10px;
}

.fixed-width {
  word-wrap: break-word;
  width: 180px;
}

.is-success > .child-of-application-link {
  color: white;
}

.filters {
  display: inline-flex;
  align-items: center;

  label {
    margin-bottom: 0;
  }
}

.application-filter {
  display: flex;
  align-items: center;
}

.pagination-select {
  width: 12rem;
  margin-right: 2rem;

  select {
    width: 12rem;
  }
}

.selection-details {
  display: flex;
  align-items: center;
  margin-top: 1.5rem;

  label {
    margin-bottom: 0;
  }
}
</style>
